//TODO improve this
window.clientId = utils.isDev() ? '19e0fy5y03q8n66xz6vs2viimlqp35' : 'hirnpvya5piis4k4n23dntu6of9bi6';
window.redirectUrl = utils.isDev() ? '19e0fy5y03q8n66xz6vs2viimlqp35' : 'hirnpvya5piis4k4n23dntu6of9bi6';

if (utils.isLocal()) {
  window.clientId = 'k01vajd2t9tzaydu0s3u1f18dywt82';
}

window.apiUrl = 'https://api.twitch.tv/helix/';
window.headers = { 
  'Client-ID': clientId,
  'Authorization': `Bearer ${utils.cookies.get('access_token')}` 
}

window.twitchAPI = {
  getUser: function(userId, callback) {
    // axios.get(`/api/user/get.php?twitchId=${userId}`, {
    //     headers: headers
    //   })
    userService.get({userId: userId})
      .then(function (response) {
        callback(response.data.data[0]);
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          authentication.refreshAccessToken({callback: function() {
            window.location.reload();
            //twitchAPI.getTwitchName(data);
          }});
        }
      });
  },
  getUsersById: function(data, callback) {
    // console.log(callback)
    const c = this;
    let url = `${apiUrl}users?`;
    for (let i in data) {
      url = `${url}id=${data[i].twitchId}&`;
    }

    axios.get(url, {
        headers: { 
          'Client-ID': clientId,
          'Authorization': `Bearer ${utils.cookies.get('access_token')}` 
        }
      })
      .then(function (response) {
        callback(response.data.data);
      })
      .catch(function (error) {
        if (error.response) {
            if (error.response.status === 401) {
                authentication.refreshAccessToken({
                    callback: function() {
                        window.location.reload();
                    }
                });
            } else if (error.response.status === 400) {
                // Handle 400 error by calling the callback with an empty array
                console.log('Bad Request: Invalid Twitch ID(s)');
                callback([]); // Pass an empty array to indicate no valid users
            } else {
                console.error('An error occurred:', error.response.status);
            }
        } else {
            console.error('An error occurred:', error.message);
        }
    });
  },
  getUserByLogin: function(login, callback) {
    const c = this;
    let url = `${apiUrl}users?login=${login}`;

    axios.get(url, {
        headers: { 
          'Client-ID': clientId,
          'Authorization': `Bearer ${utils.cookies.get('access_token')}` 
        }
      })
      .then(function (response) {
        callback(response.data.data);
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          authentication.refreshAccessToken({callback: function() {
            window.location.reload();
          }});
        }
      });
  }
}
